import { httpClient } from 'Shared/network';
import { QUERY_KEY } from '@constants';
import type { GetBankAccountsResponse } from 'viewup-api/v2';

export const getBankAccount = async (): Promise<GetBankAccountsResponse> => {
  const { data } = await httpClient.get<GetBankAccountsResponse>(QUERY_KEY.BANK_ACCOUNT_V2);
  return data;
};
